import { useState, useEffect } from 'react';
import { Button, Drawer, Form, Input, Tooltip, Space, message } from 'antd';
import { drawerWidth } from '../../../../utils/property';
import copy from 'copy-to-clipboard';
import { getPullUrlApi } from '@services/Conference';
import config from '@config';

const LiveReplay = ({ liveUrlDrawer, setLiveUrlDrawer, liveId, liveName, conferenceSlug }) => {
    const [liveUrlForm] = Form.useForm();
    const [fms, setFms] = useState(undefined);
    const [rtmpUrlVal, setRtmpUrlVal] = useState(undefined);
    const [flvUrl, setFlvUrl] = useState(undefined);
    const [rtmpUrl, setRtmpUrl] = useState(undefined);
    const [hlsUrl, setHlsUrl] = useState(undefined);
    const testUrl = conferenceSlug && liveId ? `${config.HUIYI_DOMAIN}/web/${conferenceSlug}/lives/${liveId}/test` : '';
    const pushStreamUrl = fms && rtmpUrlVal ? `${fms}/${rtmpUrlVal}` : '';
    const pushStreamCopyText = [liveName, pushStreamUrl].filter(Boolean).join('\n');
    const closeLiveUrlDrawer = () => {
        setLiveUrlDrawer(false);
    };
    const onCopyClick = type => {
        switch (type) {
            case 'liveName':
                copy(pushStreamCopyText);
                message.success('直播推流地址复制成功');
                break;
            case 'fms':
                copy(fms);
                message.success('复制 FMS URL 成功');
                break;
            case 'rtmpUrlVal':
                copy(rtmpUrlVal);
                message.success('复制播放路径/串码流成功');
                break;
            case 'flvUrl':
                copy(flvUrl);
                message.success('复制拉流地址成功');
                break;
            case 'rtmpUrl':
                copy(rtmpUrl);
                message.success('复制拉流地址(rtmp)成功');
                break;
            case 'hlsUrl':
                copy(hlsUrl);
                message.success('复制拉流地址(m3u8)成功');
                break;
            case 'copyUrl':
                if (!testUrl) {
                    message.error('测试地址生成失败，请确认会议短网址已配置');
                    break;
                }
                copy(testUrl);
                message.success('复制测试地址成功');
                break;

            default:
                break;
        }
    };

    useEffect(() => {
        if (liveId && liveUrlDrawer) {
            getPullUrlApi({ vid: liveId }).then(res => {
                if (res.status_code == 200) {
                    console.log(res.data);
                    setFms(res.data.fms);
                    setRtmpUrlVal(res.data.rtmpUrlVal);
                    setFlvUrl(res.data.flvUrl);
                    setRtmpUrl(res.data.rtmpUrl);
                    setHlsUrl(res.data.hlsUrl);
                    liveUrlForm.setFieldsValue(res.data);
                }
            });
        }
    }, [liveUrlDrawer]);
    return (
        <Drawer
            closable={{ placement: 'end' }}
            title="推流/拉流地址"
            size={drawerWidth}
            open={liveUrlDrawer}
            onClose={closeLiveUrlDrawer}
            mask={{ closable: false }}
            footer={
                <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={closeLiveUrlDrawer}>取消</Button>
                        <Button type="primary" form="uploadReplayForm" htmlType="submit" onClick={closeLiveUrlDrawer}>
                            确定
                        </Button>
                    </Space>
                </div>
            }
        >
            <Form form={liveUrlForm} layout="vertical">
                <Form.Item label="直播推流地址">
                    <div className="copy-live-name">
                        <div className="live-name">
                            {liveName}
                            {pushStreamUrl ? (
                                <>
                                    <br />
                                    {pushStreamUrl}
                                </>
                            ) : null}
                        </div>
                        <Tooltip title="复制直播推流地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('liveName')} />
                        </Tooltip>
                    </div>
                </Form.Item>

                <Form.Item label="FMS URL">
                    <Space.Compact block>
                        <Input readOnly value={fms} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title="复制 FMS URL地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('fms')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                <Form.Item label="播放路径/串码流">
                    <Space.Compact block>
                        <Input readOnly value={rtmpUrlVal} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title=" 复制 播放路径/串码流地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('rtmpUrlVal')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                <Form.Item label="拉流地址">
                    <Space.Compact block>
                        <Input readOnly value={flvUrl} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title=" 复制 拉流地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('flvUrl')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                <Form.Item label="拉流地址(rtmp)">
                    <Space.Compact block>
                        <Input readOnly value={rtmpUrl} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title=" 复制 拉流地址(rtmp)地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('rtmpUrl')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                <Form.Item label="拉流地址(m3u8)" name="hlsUrl">
                    <Space.Compact block>
                        <Input readOnly value={hlsUrl} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title=" 复制 拉流地址(m3u8)地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('hlsUrl')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                <Form.Item label="测试地址">
                    <Space.Compact block>
                        <Input readOnly value={testUrl} style={{ flex: 1, minWidth: 0 }} />
                        <Tooltip title=" 复制 测试地址">
                            <Button icon={<i className="bi bi-copy"></i>} onClick={() => onCopyClick('copyUrl')} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default LiveReplay;
